import angular from 'angular'
import React from 'react'
import 'react-dom'
import { emitter } from '../../../util.js'

angular.module('pub.bundle.step3.react', []).factory('TableStep3', TableStep3)

function TableStep3(
  $stateParams,
  $q,
  SetsService,
  CollectiblesService,
  OddsService,
  ChannelsService,
  BundleService,
  BundleCache,
) {
  return React.createClass({
    displayName: 'TableStep3',
    propTypes: {
      s3: React.PropTypes.string,
    },
    getDefaultProps: function () {
      return { s3: '' }
    },
    getInitialState: function () {
      return {
        sets: [],
        collectibles: [],
        odds: [],
        bundle: {},
        models: [],
        s3: '',
        stateColapse: false,
        onSale: false,
      }
    },
    componentDidMount: function () {
      this.load()

      emitter.on('updateData', (data) => {
        this.setState({
          productType: data.productType,
          edition: data.edition,
          setType: data.setType,
        })
        this.collapseAllSet()
      })

      emitter.on('showSoldOut', (data) => {
        this.setState({
          showSoldOut: data.status,
        })
        this.collapseAllSet()
      })
    },
    load: function () {
      if ($stateParams.channelId) {
        var cb = callback.bind(this)
        cb($stateParams.channelId)
      } else {
        SetsService.get($stateParams.parentId).then(callback.bind(this))
      }

      function callback(data) {
        var channelId = $stateParams.channelId
        if (typeof data !== 'string') {
          channelId = data.results['id-ch']
        }

        var promises = {
          bundle: BundleService.getId($stateParams.parentId, $stateParams.id),
          sets: SetsService.getChannelId(channelId, undefined, this.state.onSale, 'pct-sold'),
        }

        $q.all(promises).then(success.bind(this))

        function success(result) {
          var sets = result.sets.results
          for (var i = 0; i < sets.length; i++) {
            sets[i].o = 1
            sets[i].q = []
            sets[i].expand = false
            sets[i].colapse = false
            if (sets[i].id === parseInt($stateParams.parentId)) {
              sets.remove(sets[i])
              if (i === 0) {
                i = -1
              } else {
                i = i - 1
              }
            }
          }
          for (var i = 0; i < sets.length; i++) {
            if (sets[i].q === undefined) {
              sets[i].q = []
            }
            sets[i].q = _.orderBy(sets[i].q, 'n')
          }

          this.setState({
            sets: sets,
            bundle: result.bundle.results,
          })
        }
      }
    },
    dataCollapse: function (index) {
      if (this.state.stateColapse) {
        this.colapse(index, false, done.bind(this))
      } else {
        this.colapse(index, true, done.bind(this))
      }
      function done() {
        this.setState({
          stateColapse: !this.state.stateColapse,
        })
      }
    },
    colapse: function (index, isSelect, cb) {
      var sets = this.state.sets
      if (sets[index].colapse && isSelect === false) {
        sets[index].expand = false
        sets[index].colapse = false
        this.setState({
          sets: sets,
        })
        cb()
        return
      } else if (sets[index].colapse && isSelect) {
        cb()
        return
      }

      sets[index].expand = true
      var id = sets[index].id

      var promises = {
        collectibles: CollectiblesService.getSetId(id),
        odds: OddsService.get($stateParams.id),
      }

      $q.all(promises).then(success.bind(this))

      function success(result) {
        var collectibles = result.collectibles.results
        var odds = result.odds.results
        var len = collectibles.length
        var lenOdd = odds.length
        for (var i = 0; i < len; i++) {
          collectibles[i].o = 1
          collectibles[i].progress = 0
          collectibles[i].printCount = 0

          if (collectibles[i].t !== '') {
            collectibles[i].progress += 1
          }
          if (collectibles[i].e !== 0) {
            collectibles[i].progress += 1
          }
          if (collectibles[i].bc !== 0) {
            collectibles[i].progress += 1
          }
          if (collectibles[i]['img-t'] !== '') {
            collectibles[i].progress += 1
          }

          collectibles[i].printCount =
            collectibles[i].bc * window.Math.pow(collectibles[i].em, collectibles[i].e - 1)
          if (isNaN(collectibles[i].printCount)) {
            collectibles[i].printCount = 0
          }

          if (odds.length === 0) {
            collectibles[i].tog = false
          } else {
            for (var j = 0; j < lenOdd; j++) {
              if (collectibles[i].id === odds[j]['id-q']) {
                collectibles[i].tog = true
              }
            }
            if (collectibles[i].tog === undefined) {
              collectibles[i].tog = false
            }
          }
        }

        collectibles = _.orderBy(collectibles, 'n')
        if (this.state.productType && this.state.productType?.length > 0) {
          // I have collectibles an array of objects and I want to filter it by the productType that is array of numbers
          collectibles = _.filter(collectibles, (collectible) =>
            this.state.productType.includes(collectible['k-prod']),
          )
        }
        if (this.state.edition && this.state.edition?.length > 0) {
          collectibles = _.filter(collectibles, (collectible) =>
            this.state.edition.includes(collectible['e']),
          )
        }
        if (this.state.setType && this.state.setType?.length > 0) {
          collectibles = _.filter(collectibles, (collectible) =>
            this.state.setType.includes(collectible?.s['k']),
          )
        }
        if (!this.state.showSoldOut) {
          collectibles = _.filter(collectibles, (collectible) => collectible['st'] !== 2)
        }

        sets[index].q = collectibles
        sets[index].expand = false
        sets[index].colapse = !sets[index].colapse
        this.setState({
          sets: sets,
          odds: odds,
          collectibles: collectibles,
        })
        cb()
      }
    },
    collapseAllSet: function () {
      var sets = this.state.sets
      for (var i = 0; i < sets.length; i++) {
        sets[i].expand = false
        sets[i].colapse = false
      }
      this.setState({
        sets: sets,
      })
    },
    toogleChange: function (index, indexDad) {
      if (!this.canEditCollectibles()) {
        return
      }
      var setDad = angular.copy(this.state.sets[indexDad])
      setDad.q = []
      this.state.sets[indexDad].q[index].tog = !this.state.sets[indexDad].q[index].tog
      this.state.sets[indexDad].q[index].tog === true
        ? this.add(this.state.sets[indexDad].q[index], setDad)
        : this.remove(this.state.sets[indexDad].q[index], setDad, index, indexDad)
    },
    filterOnSale: function () {
      this.setState(
        {
          onSale: !this.state.onSale,
        },
        () => {
          this.load()
        },
      )
    },
    saveAll: function (index) {
      if (!this.canEditCollectibles()) {
        return
      }

      this.colapse(index, this.state.stateColapse, done.bind(this))

      function done() {
        this.setState({
          stateColapse: true,
        })
        var isSelectAll = true
        var promise = []
        var oddsDeleted = []
        var sets = this.state.sets
        var odds = this.state.odds
        var models = this.state.models

        for (var i = 0; i < sets[index].q.length; i++) {
          if (sets[index].q[i].tog === false) {
            sets[index].q[i].tog = true
            var setDad = angular.copy(sets[index])
            setDad.q = []
            if (sets[index].q[i].tog) {
              this.addCache(sets[index].q[i], setDad)
            }
            isSelectAll = false
          }
        }

        if (models.length > 0) {
          OddsService.save(parseInt($stateParams.id), models).then(successFirst.bind(this))

          function successFirst(result) {
            var oddsResult = result.results
            for (var i = 0; i < oddsResult.length; i++) {
              odds.push(oddsResult[i])
            }
            models = []
            this.setState({
              sets: sets,
              odds: odds,
              models: models,
            })
            this.forceUpdate()
            toastr.success('Saved!')
          }
        } else if (models.length === 0 && isSelectAll) {
          for (var i = 0; i < sets[index].q.length; i++) {
            sets[index].q[i].tog = false
            var itemDelete
            var len = odds.length
            for (var j = 0; j < len; j++) {
              if (odds[j]['id-q'] === sets[index].q[i].id) {
                itemDelete = odds[j]
                oddsDeleted.push(itemDelete)
                break
              }
            }

            if (itemDelete.id !== undefined) {
              promise.push(OddsService.deleteOdd(itemDelete.id))
            }
          }

          $q.all(promise).then(success.bind(this), error.bind(this))

          function success(result) {
            for (var i = 0; i < oddsDeleted.length; i++) {
              odds.remove(oddsDeleted[i])
            }
            oddsDeleted = []
            this.setState({
              sets: sets,
              odds: odds,
              models: models,
            })
            this.forceUpdate()
          }

          function error(result) {
            for (var i = 0; i < sets[index].q.length; i++) {
              sets[index].q[i].tog = true
            }
            this.setState({
              sets: sets,
              odds: odds,
              models: models,
            })
            this.forceUpdate()
            swal(result.error.message)
          }
        }
      }
    },
    canEditCollectibles: function () {
      var st = this.state && this.state.bundle ? this.state.bundle.st : undefined
      st = parseInt(st, 10)

      var isDraft = !isNaN(st) && st === 0
      if (isDraft) {
        return true
      }

      // Show the warning once per page load to avoid spamming alerts.

      swal({
        title: 'This pack is published. You cannot make changes to collectibles',
        type: 'warning',
        animation: 'slide-from-top',
        allowEscapeKey: false,
        allowOutsideClick: false,
      })

      return false
    },
    addCache: function (item, setDad) {
      var model = {
        'id-b': parseInt($stateParams.id),
        'id-s': parseInt($stateParams.parentId),
        o: 1000,
        'id-q': item.id,
        t: item.t,
        'img-t': item['img-t'],
        cr: item.cr,
      }

      if (this.state.odds.length === 0) {
        setDad.q.push(model)
        this.state.models.push(model)
        BundleCache.addOddsOtherSets(setDad)
        this.setState({
          models: this.state.models,
        })

        return
      }

      var len = this.state.odds.length
      for (var i = 0; i < len; i++) {
        if (this.state.odds[i]['id-q'] !== item.id) {
          setDad.q.push(model)
          this.state.models.push(model)
          BundleCache.addOddsOtherSets(setDad)
          this.setState({
            models: this.state.models,
          })
          return
        }
      }
    },
    add: function (item, setDad) {
      var model = {
        'id-b': parseInt($stateParams.id),
        o: 1000,
        'id-q': item.id,
        t: item.t,
        'img-t': item['img-t'],
        cr: item.cr,
      }

      if (this.state.odds.length === 0) {
        OddsService.save(model['id-b'], [model]).then(success.bind(this))

        function success(result) {
          model.id = result.results[0].id
          setDad.q.push(model)
          this.state.odds.push(model)
          BundleCache.addOddsOtherSets(setDad)
          this.setState({
            odds: this.state.odds,
          })
        }

        return
      }

      var len = this.state.odds.length
      for (var i = 0; i < len; i++) {
        if (this.state.odds[i]['id-q'] !== item.id) {
          OddsService.save(model['id-b'], [model]).then(success.bind(this))

          function success(result) {
            model.id = result.results[0].id
            setDad.q.push(model)
            this.state.odds.push(model)
            BundleCache.addOddsOtherSets(setDad)
            this.setState({
              odds: this.state.odds,
            })
          }

          return
        }
      }
    },
    remove: function (item, setDad, index, indexDad) {
      var itemDelete
      var len = this.state.odds.length
      for (var i = 0; i < len; i++) {
        if (this.state.odds[i]['id-q'] === item.id) {
          itemDelete = this.state.odds[i]
          break
        }
      }

      if (itemDelete.id === undefined) {
        return
      }

      OddsService.deleteOdd(itemDelete.id).then(success.bind(this), error.bind(this))

      function success() {
        this.state.odds.remove(itemDelete)
        var oddsCorrect = []
        for (var i = 0; i < this.state.odds.length; i++) {
          if (this.state.odds[i].q !== undefined) {
            if (this.state.odds[i].q['id-s'] === setDad.id) {
              oddsCorrect.push(this.state.odds[i])
            }
          } else {
            if (this.state.odds[i]['id-s'] === setDad.id) {
              oddsCorrect.push(this.state.odds[i])
            }
          }
        }
        setDad.q = oddsCorrect
        BundleCache.removeOddsOtherSets(setDad)
        this.state.sets[indexDad].q[index].tog = false
        this.setState({
          odds: this.state.odds,
          sets: this.state.sets,
        })
      }

      function error(result) {
        this.state.sets[indexDad].q[index].tog = true
        this.setState({
          sets: this.state.sets,
        })
        swal(result.error.message)
      }
    },
    render: function () {
      return React.createElement(
        'table',
        { className: 'table' },
        React.createElement(
          'thead',
          null,
          React.createElement(
            'tr',
            { className: 'table-header' },
            React.createElement('th', null, 'Thumb'),
            React.createElement('th', null, 'Title'),
            React.createElement('th', null, 'Status'),
            React.createElement('th', null, 'Type'),
            React.createElement('th', null, 'Edition'),
            React.createElement('th', null, '% Sold Out'),
            React.createElement('th', null, '# of Cards'),
            React.createElement(
              'th',
              {
                style: { width: '200px' },
                className: 'text-center',
              },
              React.createElement(
                'label',
                {
                  className: '!text-white !font-semibold !mr-4',
                },
                'Filter: On Sale',
              ),
              React.createElement('input', {
                type: 'checkbox',
                checked: this.state.onSale,
                className: '!m-0',
                onChange: this.filterOnSale,
              }),
            ),
          ),
        ),
        this.state.sets.map(function (item, i) {
          var url = this.props.s3 + '/sets/' + item['img-t']
          var isVideo =
            item['img-t'] &&
            (item['img-t'].indexOf('.mp4') !== -1 || item['img-t'].indexOf('.mov') !== -1)
          var indexDad = i
          return React.createElement(
            'tbody',
            { key: i },
            React.createElement(
              'tr',
              null,
              React.createElement(
                'td',
                { style: { width: '230px' } },
                isVideo
                  ? React.createElement('video', {
                      style: { height: '75px', width: '75px', objectFit: 'contain' },
                      src: url,
                      autoPlay: true,
                      loop: true,
                      muted: true,
                      playsInline: true,
                    })
                  : React.createElement('img', {
                      style: { height: '75px', width: '75px' },
                      'data-src': url,
                      className: 'lazyload',
                    }),
              ),
              React.createElement('td', null, React.createElement('label', null, item.t)),
              React.createElement(
                'td',
                null,
                item.st === 1
                  ? React.createElement('label', null, 'Live')
                  : React.createElement('label', null, 'Pending'),
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'label',
                  null,
                  item['k'] === 0 ? `STANDARD` : item['k'] === 1 ? `AWARD` : `COLLECTORS EDITION`,
                ),
              ),
              React.createElement('td', null, React.createElement('label', null, item.e)),
              React.createElement('td', null, React.createElement('label', null, item['pct-sold'])),
              React.createElement(
                'td',
                null,
                item.q.length == 0
                  ? React.createElement('label', null, 'Expand to View')
                  : React.createElement('label', null, item.q.length),
              ),
              React.createElement(
                'td',
                null,
                React.createElement(
                  'button',
                  {
                    className: 'btn btn-default',
                    onClick: this.saveAll.bind(this, i),
                  },
                  'Select All',
                  item.expand === true
                    ? React.createElement('i', {
                        className: 'fa fa-refresh fa-spin',
                      })
                    : React.createElement('span', null),
                ),
                React.createElement(
                  'button',
                  {
                    style: { marginLeft: '20px' },
                    className: 'btn btn-default',
                    onClick: this.dataCollapse.bind(this, i),
                  },
                  React.createElement(
                    'span',
                    null,
                    'Expand',
                    item.expand === true
                      ? React.createElement('i', {
                          className: 'fa fa-refresh fa-spin',
                        })
                      : React.createElement('span', null),
                  ),
                ),
              ),
            ),
            item.colapse === true
              ? React.createElement(
                  'tr',
                  null,
                  React.createElement(
                    'td',
                    {
                      colSpan: '9',
                      style: { paddingLeft: '40px', width: '100%' },
                    },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'table',
                        { className: 'table' },
                        React.createElement(
                          'tbody',
                          null,
                          item.q.map(function (children, i) {
                            var url = this.props.s3 + '/collectibles/' + children['img-t']
                            var isVideo =
                              children['img-t'] &&
                              (children['img-t'].indexOf('.mp4') !== -1 ||
                                children['img-t'].indexOf('.mov') !== -1)
                            return React.createElement(
                              'tr',
                              { key: i },
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                React.createElement('label', null, children.n),
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                isVideo
                                  ? React.createElement('video', {
                                      style: {
                                        height: '75px',
                                        width: '75px',
                                        objectFit: 'contain',
                                      },
                                      src: url,
                                      autoPlay: true,
                                      loop: true,
                                      muted: true,
                                      playsInline: true,
                                    })
                                  : React.createElement('img', {
                                      style: { height: '75px', width: '75px' },
                                      'data-src': url,
                                      className: 'lazyload',
                                    }),
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                React.createElement('label', null, children.t),
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                React.createElement('label', null, children.cr),
                              ),
                              React.createElement(
                                'td',
                                { className: 'no-border-top' },
                                React.createElement('input', {
                                  type: 'checkbox',
                                  checked: children.tog,
                                  onChange: this.toogleChange.bind(this, i, indexDad),
                                }),
                              ),
                            )
                          }, this),
                        ),
                      ),
                    ),
                  ),
                )
              : React.createElement('tr', null),
          )
        }, this),
      )
    },
  })
}
